import * as React from 'react';
import { css } from 'aphrodite';
import history from 'login-utils/history';
import { inputMasks } from '@blend/ui-common';

import InputMap from 'login-components/Common/Inputs/InputMap';
import States from 'login-constants/states';
import * as onboardingForm from 'login-utils/onboardingForm';
import * as formUtils from 'login-utils/formUtils';
import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';
import { paneFormStyles } from 'login-components/Common/PaneLayout/paneStyles';
import { DataShape, Field, FormProps, reduxForm } from 'redux-form';

const inputs: FormInput[] = [
  {
    ...InputMap.PhoneInput,
    identifier: 'phone number',
    name: onboardingForm.FIELDS.phoneNumber,
    label: 'Phone number',
    normalize: inputMasks.PHONE.normalize,
    mask: inputMasks.PHONE.maskedInputConfig as any,
  },
];

class ProvidePhoneNumber extends React.Component<FormProps<DataShape, {}, ReduxState>> {
  returnToJourneyChooser = event => {
    // We don't want to use reduxForm's submit functionality here because since we're going to JOURNEY_CHOOSER,
    // we're actually going back to a previous page of the form, so we're not submitting it. Using submit would run
    // mark all fields from JOURNEY_CHOOSER as touched, which we don't want to do yet.
    // Valid is a prop provided by redux-form; it's true if we passed validation and false if we failed.
    event.preventDefault();
    const { valid } = this.props;
    if (!valid) return;
    history.push(`${States.JOURNEY_CHOOSER}`);
  };

  render() {
    return (
      <form noValidate className={css(paneFormStyles.wrapper)} onSubmit={this.returnToJourneyChooser}>
        <div>
          <div className={css(paneFormStyles.inputsWrapper)}>
            {inputs.map(input => (
              <div className={css(paneFormStyles.fieldWrapper)} key={input.name}>
                <Field {...input} />
              </div>
            ))}
          </div>
        </div>
        <div className={css(paneFormStyles.buttonPadding)}>
          <div className={css(paneFormStyles.buttonDisplay)}>
            <PrimaryButton type="submit" isWide text="Save" fontFamily="Roboto" data-it="ProvidePhoneNumber-continue" />
          </div>
        </div>
      </form>
    );
  }
}

const ConnectedProvidePhoneNumber = reduxForm<FormProps<DataShape, {}, ReduxState>, {}>({
  ...onboardingForm.FORM_CONFIG,
  validate: (values: DataShape) => formUtils.validate(inputs, values),
})(ProvidePhoneNumber);

export default ConnectedProvidePhoneNumber;
